import UserNav from "./components/sideNavbar";
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import { Route, Switch, useRouteMatch } from "react-router";
import { UserNotificationPage } from "./notifications";
import UserHomePage from "./home";
import UserOfferPage from "./offers";
import UserVehiclesRoute from './vehiclesRoute';
import Profile from "./profile";
import ProtectedRoute from "../components/protectedRoute";
import NotFoundPage404 from "../pages/_errors/404";
import MyBookings from "./myBookings";
import UserOrdersPage from "./userOrders";
import { FavoritePage } from "./favorite";
import { useTranslation } from "react-i18next";
import "./UserV7.scss";

SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

export function UserPage() {
    const { path, url } = useRouteMatch();
    const { i18n } = useTranslation();
    const languageDir = 'language-' + (i18n.language || 'ar');

    return (
        <div className="user-page-container">
            <div className={`user-ctn-v7 py-10 ${languageDir}`}>
                <div className="user-grid-v7">
                    <UserNav url={url} />
                    <div className="user-page-content-v7 mt-6 lg:mt-0">
                        <Switch>
                            <Route exact path={path} component={UserHomePage} />
                            <ProtectedRoute exact path={`${path}/profile`} component={Profile} />
                            <Route exact path={`${path}/notifications`} component={UserNotificationPage} />
                            <Route exact path={`${path}/offers`} component={UserOfferPage} />
                            <Route exact path={`${path}/favorite`} component={FavoritePage} />
                            <Route path={`${path}/vehicles`} component={UserVehiclesRoute} />
                            <Route exact path={`${path}/myOrders`} component={UserOrdersPage} />
                            <Route exact path={`${path}/myBookings/`} component={MyBookings} />
                            <Route component={NotFoundPage404} />
                        </Switch>
                    </div>
                </div>
            </div>
        </div>
    );
}